import { useState } from "react";
import { Alert, Loader } from '../../../core/components';
import { InfoMessageService, TranslationService } from '../../../core/services';
import ManualInstallmentPlan from './components/ManualInstallmentPlan/ManualInstallmentPlan';
import { InstallmentPlanTypeEnum } from './types/InstallmentPlanTypeEnum';
import { useQuery } from 'react-query';
import InstallmentPlanApi from './api/InstallmentPlanApi';
import { ActionStatusType } from '../../../core/types/ActionStatusType';
import { ViewModel } from './types/ViewModel';
import { useParams } from "react-router-dom";

type InstallmentPlanType = {
  installmentViewName: InstallmentPlanTypeEnum;
  viewModel: ViewModel;
};

type Props = {
  onClose: () => void;
};

const InstallmentPlan = (props: Props) => {
  const { caseNumber, tenantUId } = useParams() as { caseNumber: string; tenantUId: string; };
  const [errorMsg, setErrorMsg] = useState<string>(TranslationService.translate('GeneralErrorMsg'));

  const installmentPlan = useQuery<ActionStatusType<InstallmentPlanType>>(
    ['installmentPlan', caseNumber],
    () => InstallmentPlanApi.GetInstallmentPlan(caseNumber),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      retryOnMount: true,
      onSuccess: (data) => {
        if (!data.success) {
          setErrorMsg(data.message);
        }
      },
      onError: () => {
        InfoMessageService.error(
          TranslationService.translate('GeneralErrorMsg')
        );
      },
    }
  );

  const handleOnClose = () => {
    installmentPlan.remove();
    props.onClose();
  };

  const renderInstallmentPlan = () => {
    switch (installmentPlan.data?.data.installmentViewName) {
      case InstallmentPlanTypeEnum.Manual:
        return (
          <ManualInstallmentPlan
            model={installmentPlan.data?.data.viewModel}
            onClose={handleOnClose}
          />
        );
      case InstallmentPlanTypeEnum.Pending:
        return (
          <Alert
            className="mb-0"
            variant={Alert.Variants.Info}
            text={TranslationService.translate('InstallmentPlanHandled')}
          />
        );
      case InstallmentPlanTypeEnum.Registered:
      return (
        <Alert
          className="mb-0"
          variant={Alert.Variants.Info}
          text={installmentPlan.data?.data.viewModel.infoMsg}
        />
      );
      default:
        return (
          <Alert
            className="mb-0"
            variant={Alert.Variants.Info}
            text={TranslationService.translate(
              'InstallmentPlanNoTypesSuporrted'
            )}
          />
        );
    }
  };

  return (
    <>
      {installmentPlan.isLoading ? (
        <Loader />
      ) : (
        <>
          {installmentPlan.data?.data ? (
            renderInstallmentPlan()
          ) : (
            <>
              <Alert
                className="mb-0"
                variant={Alert.Variants.Info}
                text={errorMsg}
              />
            </>
          )}
        </>
      )}
    </>
  );
};

export default InstallmentPlan;
